import React from "react";
import "./Intro.css";

export default function Intro() {
  return (
    <div className="Intro">
      <div className="color"></div>
      <div className="containerImaam">
        <h1 className="containerItemsHead">RASHIED OMAR</h1>
        <div className="containerItems">
          <div className="imageContainer">
            <h3>INTRODUCING OUR</h3>
            <h2>CURRENT IMAM</h2>
            <img className="Imaam" src="assets/Rectangle 44.png" alt="" />
          </div>
          <h1 className="containerItemsHead-mobile">RASHIED OMAR</h1>
          <div className="textContain">
            <br />
            <p>
              Dr. Rashied Omar is Research Scholar of Islamic Studies &
              Peacebuilding at the Kroc Institute for International Peace
              Studies, University of Notre Dame. His research and teaching
              focuses on the roots of religious violence and the potential of
              religion for constructive social engagement and interreligious
              peacebuilding.
            </p>
            <hr />
          </div>
        </div>
      </div>
      <div className="aboutIntro">
        <h2>Introduction</h2>
        <br />
        <h1>About</h1>
        <br />
        <p>
          The Claremont Main Road Mosque (CMRM), established in 1854, has a
          history of critically reflecting on and engaging with issues that
          affect us as Muslim citizens, locally and globally.
        </p>
        <br />
        <p>
          Many people have been drawn to this mosque over the years because of
          our strong commitment to the anti-Apartheid struggle and our
          compassionate and comprehensive vision of Islam.
        </p>
        <br />
        <p>
          Join us on our mission to build an institutional legacy for future
          generations, of bearing witness and upholding the virtues of social
          justice and compassion.
        </p>
      </div>
    </div>
  );
}
